import { render, staticRenderFns } from "./NotifyListView.vue?vue&type=template&id=0bb657ba&scoped=true"
import script from "./NotifyListView.vue?vue&type=script&lang=js"
export * from "./NotifyListView.vue?vue&type=script&lang=js"
import style0 from "./NotifyListView.vue?vue&type=style&index=0&id=0bb657ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb657ba",
  null
  
)

export default component.exports